import React, {createContext, useContext, useEffect, useState} from 'react';
import {SupportedThemes, UserInfo} from "../types/types";
import {PrimeReactContext} from "primereact/api";
import {useResizeListener} from "primereact/hooks";

export const UserContext = createContext<any>(null);


export const UserContextProvider = (props: any) => {
    const {changeTheme} = useContext(PrimeReactContext);
    const initialState: UserInfo = {
        authenticated: false,
        theme: 'light'
    }
    const [userInfo, setUserInfo] = useState(initialState);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    function isSupportedTheme(theme: string | null): theme is SupportedThemes {
        if (!theme) return false;
        return ['dark', 'light'].includes(theme);
    }

    useEffect(() => {
        const theme = localStorage.getItem('theme');
        if (isSupportedTheme(theme)) {
            if (changeTheme){
                if (theme === 'light') {
                    changeTheme('bootstrap4-dark-blue', 'saga-orange', 'theme-link');
                } else {
                    changeTheme('saga-orange', 'bootstrap4-dark-blue', 'theme-link');
                }
            }
            setUserInfo(prevState => {
                return {...prevState, theme}
            });
        }
    }, []);

    const [bindWindowResizeListener, unbindWindowResizeListener] = useResizeListener({
        listener: (event) => {
            // @ts-ignore
            setIsMobile(event.currentTarget.innerWidth < 992);
        }
    });

    const updateUserInfo = (userInfo: Partial<UserInfo>) => {
        setUserInfo(prevState => {
            return {...prevState, ...userInfo}
        });
    }

    const handleThemeChange = (theme: SupportedThemes) => {
        setUserInfo(prevState => {
            return {...prevState, theme}
        })
        localStorage.setItem('theme', theme);
    }

    useEffect(() => {
        bindWindowResizeListener();

        return () => {
            unbindWindowResizeListener();
        };
    }, [bindWindowResizeListener, unbindWindowResizeListener]);

    return <>
        <UserContext.Provider value={{userInfo, updateUserInfo, handleThemeChange, isMobile}}>
            {props.children}
        </UserContext.Provider>
    </>
};
